<ng-container *ngIf="positionRowData">
    <ng-container *ngIf="positionRowData.isExpanded$ && positionRowData.isExpanded$ | async; else value">
        <div class="w-full pr-2 box-border flex items-center gap-2 flex-wrap">
            <ng-container [ngTemplateOutlet]="icons"></ng-container>
            <app-arl-information-input
                class="grow"
                [informationControl]="positionRowData.form.controls.Information"
                [ARLType]="type"
                [inputMode]="getInputMode()"
                [entityId]="getEntityId()"
                (entitySelected)="setEntityId.emit({id: $event?.id, m2s: $event?.materialToSupplier})"
                #infoInput
            ></app-arl-information-input>
        </div>

        <div class="flex justify-between items-center" *ngIf="getEntityId()">
            <div *ngIf="material$ | async as material">{{ material.DisplayName }}</div>
            <div *ngIf="resource$ | async as resource">{{ resource.DisplayName }}</div>
            <div *ngIf="jobSpecification$ | async as jobSpecification">{{ jobSpecification.Name }}</div>
            <button type="button" mat-icon-button (click)="infoInput.onDropDownSelected(null); this.setEntityId.emit({id: null, m2s: null});"><fa-icon icon="times"></fa-icon></button>
        </div>
    </ng-container>
    <ng-template #value>
        <!--                    {{ positionRawData.entity?.Information }}-->
        <ng-container [ngTemplateOutlet]="icons"></ng-container>
        {{ positionRowData.form?.controls.Information.getRawValue() }}
    </ng-template>
    <ng-template #icons>
        <fa-icon icon="signs-post" *ngIf="positionRowData.form?.controls.IsOptional.getRawValue()" style="margin-right: 0.5rem" matTooltip="optional"></fa-icon>
        <fa-icon icon="slash" *ngIf="positionRowData.form?.controls.CrossedOut.getRawValue()" style="margin-right: 0.5rem" matTooltip="gestrichen"></fa-icon>
        <fa-icon icon="snowflake" *ngIf="positionRowData.form?.controls.FixedPrices.getRawValue()" style="margin-right: 0.5rem" matTooltip="Preis eingefroren"></fa-icon>
        <fa-icon icon="percentage" *ngIf="positionRowData.form?.controls.BaseCostAllowances.getRawValue()?.length > 0" style="margin-right: 0.5rem" matTooltip="Rabatt / Zuschlag gesetzt"></fa-icon>
    </ng-template>
</ng-container>
<strong *ngIf="groupRowData">Summe {{ groupRowData.information$ | async }}</strong>
